
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebookBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M15.856 28.4a.5.5 0 0 1-.5.5H2.446A1.545 1.545 0 0 1 .9 27.355V2.445C.9 1.592 1.592.9 2.445.9h24.91c.853 0 1.545.692 1.545 1.545v24.91c0 .853-.692 1.545-1.545 1.545h-6.636a.5.5 0 0 1-.5-.5V18.057h3.2a.5.5 0 0 0 .496-.436l.416-3.226a.5.5 0 0 0-.496-.564H20.22v-2.698c0-1.223.34-2.057 2.095-2.057h1.738a.5.5 0 0 0 .5-.5V5.732a.48.48 0 0 0-.436-.483 33.22 33.22 0 0 0-2.825-.121c-3.227 0-5.435 1.97-5.435 5.586v3.116h-3.15a.5.5 0 0 0-.5.5v3.226a.5.5 0 0 0 .5.5h3.15V28.4Z",
  stroke: "#000",
  strokeWidth: 1.8
})));

      const __svgRaw = "<svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.8556 28.4C15.8556 28.6762 15.6317 28.9 15.3556 28.9H2.44529C1.59154 28.9 0.899902 28.208 0.899902 27.3545V2.4454C0.899902 1.59177 1.59165 0.900024 2.44529 0.900024H27.3546C28.208 0.900024 28.8999 1.59177 28.8999 2.4454V27.3545C28.8999 28.2081 28.2079 28.9 27.3546 28.9H20.7195C20.4434 28.9 20.2195 28.6762 20.2195 28.4V18.0569H23.4194C23.6708 18.0569 23.8831 17.8702 23.9153 17.6208L24.3313 14.3951C24.3698 14.096 24.1369 13.8311 23.8354 13.8311H20.2195V11.1332C20.2195 9.90978 20.5592 9.07603 22.3137 9.07603L24.0516 9.07527C24.3276 9.07515 24.5513 8.85132 24.5513 8.57527V5.73337C24.5513 5.48272 24.366 5.27199 24.1164 5.24957C23.51 5.19513 22.4627 5.12894 21.2906 5.12894C18.0644 5.12894 15.8556 7.09825 15.8556 10.7147V13.8311H12.7067C12.4306 13.8311 12.2067 14.055 12.2067 14.3311V17.5569C12.2067 17.833 12.4306 18.0569 12.7067 18.0569H15.8556V28.4Z\" stroke=\"black\" stroke-width=\"1.8\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/facebook-black.cb3949812e29d00510cd0f7040a7844d.svg"),
        {
          React: SvgFacebookBlack,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      